export class SapHanaInstance {
    'sid';
    'instanceNumber';
    'version';
    'isExpress';
    'isSharded';
    'isReplicated';
    'isPrimary';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sid",
            "baseName": "sid",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceNumber",
            "baseName": "instanceNumber",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "string",
            "format": ""
        },
        {
            "name": "isExpress",
            "baseName": "isExpress",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isSharded",
            "baseName": "isSharded",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isReplicated",
            "baseName": "isReplicated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isPrimary",
            "baseName": "isPrimary",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapHanaInstance.attributeTypeMap;
    }
    constructor() {
    }
}
